import { Helmet } from 'react-helmet'

const TermsOfService = () => {
  return (
        <>
            <Helmet>
                <title>Terms of Service</title>
                <meta
                name="description"
                content="."
                />
                <meta name="keywords" content="" />
                <meta name="author" content="Pulse by Canned Head" />
                <meta name="robots" content="index, follow" />
                <meta property="og:title" content="" />
                <meta property="og:description" content="" />
                <meta property="og:image" content="https://example.com/image.jpg" />
                <meta property="og:url" content="https://example.com/time-tracking-software" />
                <meta property="og:type" content="website" />
            </Helmet>
            <div className="container py-5 terms-of-service">
                <h1 className='mt-4'>Terms of Service</h1>
                <p><strong>Effective Date:</strong> September 1st, 2024</p>
                <p>
                    Welcome to Pulse, a time-tracking application provided by Loopboard Inc. (&quot;Company&quot;, &quot;we&quot;, &quot;our&quot;, or &quot;us&quot;). By accessing or using our service (&quot;Service&quot;), you agree to comply with and be bound by these Terms of Service (&quot;Terms&quot;). Please read them carefully.
                </p>

                <h2 className="mt-4">1. Acceptance of Terms</h2>
                <p>
                    By creating an account, accessing, or using Loopboard.io, you agree to these Terms. If you do not agree to these Terms, you must not use the Service.
                </p>

                <h2 className="mt-4">2. Eligibility</h2>
                <p>
                    You must be at least 18 years old or the legal age of majority in your jurisdiction to use Loopboard.io. By using the Service, you represent and warrant that you meet this requirement.
                </p>

                <h2 className="mt-4">3. Account Registration</h2>
                <p>
                    To use the Service, you must create an account. You agree to provide accurate, current, and complete information during the registration process and to update such information to keep it accurate, current, and complete. You are responsible for safeguarding your password and agree not to disclose it to any third party.
                </p>

                <h2 className="mt-4">4. Use of Service</h2>
                <p>
                    Pulse is a time-tracking tool designed to help businesses and individuals monitor and manage their time. You agree to use the Service only for lawful purposes and in accordance with these Terms.
                </p>

                <h3>4.1 Prohibited Uses</h3>
                <p>You agree not to:</p>
                <ul>
                    <li>Use the Service in any way that violates applicable laws or regulations.</li>
                    <li>Engage in any activity that could disable, overburden, damage, or impair the Service.</li>
                    <li>Attempt to gain unauthorized access to any portion of the Service, accounts, or networks connected to the Service.</li>
                    <li>Use any automated means to access the Service for any purpose without our express permission.</li>
                </ul>

                <h2 className="mt-4">5. Subscription and Billing</h2>
                <p>
                    Pulse may offer both free and paid subscription plans. By subscribing to a paid plan, you agree to pay the applicable fees as described on our website. Payments will be charged on a recurring basis as per the chosen plan, unless canceled by you.
                </p>

                <h3>5.1 Free Trial</h3>
                <p>
                    We may offer free trial periods for our paid plans. If you do not cancel your subscription before the trial period ends, you will be automatically enrolled in the paid plan, and your payment method will be charged.
                </p>

                <h3>5.2 Refunds</h3>
                <p>
                    All fees paid are non-refundable unless otherwise specified in our refund policy. We reserve the right to modify our refund policy at any time.
                </p>

                <h2 className="mt-4">6. User Content</h2>
                <p>
                    You may submit, upload, or otherwise make available content through the Service (&quot;User Content&quot;). You retain ownership of any intellectual property rights that you hold in that content.
                </p>

                <h3>6.1 License to User Content</h3>
                <p>
                    By submitting User Content, you grant Loopboard Inc. a worldwide, non-exclusive, royalty-free license to use, store, reproduce, modify, and distribute your content for the purposes of operating, promoting, and improving our Service.
                </p>

                <h3>6.2 Content Restrictions</h3>
                <p>You agree not to submit content that:</p>
                <ul>
                    <li>Is illegal, harmful, or violates the rights of others.</li>
                    <li>Contains viruses or other harmful code.</li>
                    <li>Is spam, or designed to promote unauthorized or illegal activities.</li>
                </ul>

                <h2 className="mt-4">7. Data Privacy</h2>
                <p>
                    Your privacy is important to us. Our <a href="/privacy-policy">Privacy Policy</a> explains how we collect, use, and protect your personal information. By using the Service, you agree to the terms of the Privacy Policy.
                </p>

                <h2 className="mt-4">8. Intellectual Property</h2>
                <p>
                    Loopboard Inc. owns all rights, titles, and interests in and to the Service, including all intellectual property rights. You are granted a limited, non-exclusive, non-transferable license to access and use the Service for your personal or internal business purposes.
                </p>

                <h2 className="mt-4">9. Termination</h2>
                <p>
                    We may terminate or suspend your account and access to the Service at our sole discretion, without prior notice or liability, for any reason, including but not limited to a breach of these Terms. Upon termination, your right to use the Service will immediately cease.
                </p>

                <h2 className="mt-4">10. Disclaimers and Limitation of Liability</h2>
                <h3>10.1 No Warranty</h3>
                <p>
                    The Service is provided &quot;as is&quot; and &quot;as available&quot; without warranties of any kind, either express or implied, including but not limited to the implied warranties of merchantability, fitness for a particular purpose, or non-infringement.
                </p>

                <h3>10.2 Limitation of Liability</h3>
                <p>
                    In no event shall Loopboard Inc., its affiliates, directors, employees, or agents be liable for any indirect, incidental, special, consequential, or punitive damages, including but not limited to loss of profits, data, or use, whether in an action in contract, tort, or otherwise, arising out of or in connection with the Service.
                </p>

                <h2 className="mt-4">11. Indemnification</h2>
                <p>
                    You agree to indemnify, defend, and hold harmless Loopboard Inc., its affiliates, directors, employees, and agents from and against any claims, liabilities, damages, losses, and expenses, including reasonable attorney&apos;s fees, arising out of or in any way connected with your access to or use of the Service, your violation of these Terms, or your violation of any rights of another.
                </p>

                <h2 className="mt-4">12. Governing Law</h2>
                <p>
                    These Terms shall be governed by and construed in accordance with the laws of the State of Delaware, without regard to its conflict of law principles.
                </p>

                <h2 className="mt-4">13. Dispute Resolution</h2>
                <p>
                    Any disputes arising out of or relating to these Terms or the Service shall be resolved through binding arbitration in Delaware in accordance with the rules of the American Arbitration Association. You agree that any dispute resolution proceedings will be conducted only on an individual basis and not in a class, consolidated, or representative action.
                </p>

                <h2 className="mt-4">14. Changes to Terms</h2>
                <p>
                    We reserve the right to modify these Terms at any time. If we make material changes, we will notify you by email or through the Service. Your continued use of the Service after the changes become effective constitutes your acceptance of the new Terms.
                </p>

                <h2 className="mt-4">15. Contact Us</h2>
                <p>
                    If you have any questions or concerns about these Terms, please contact us at:
                </p>
                <p>
                    <strong>Loopboard Inc.</strong><br />
                    1111B S Governors Ave STE 21944<br />
                    Dover, DE 19904<br />
                    Email: info@loopboard.io<br />
                    Phone: (786) 605-8053
                </p>
            </div>
        </>
  )
}

export default TermsOfService
